import { ListItem, List, Text, Box } from "@chakra-ui/react";
// import { MdChat} from "react-icons/md"
import { formatDistance } from "date-fns";
import DOMPurify from "dompurify";

export default function Comments(props) {
   // console.log(props.comments)
  return (
    <List spacing={3}>
      {props.comments &&
        props.comments.map((c, i) => {
          return (
            <ListItem key={i} borderWidth="1px" borderRadius="lg" p={4}> 
              <Box dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize((c.comment.replace(/&lt;/g,'<')))}} />
              <Text fontSize="10px" textAlign="right">
                {c.author}
              </Text>
              <Text fontSize="10px" textAlign="right">
                {formatDistance(new Date(), new Date(c.date), {
                  addSuffix: true,
                })}
              </Text>
            </ListItem>
          );
        })}
    </List>
  );
}
